import { useState } from "react";
import { X } from "lucide-react";

const REASONS = [
  "Team not a fit",
  "Market too small",
  "Traction insufficient",
  "Valuation too high",
  "Competitive concerns",
  "Timing / stage mismatch",
  "Portfolio conflict",
  "Regulatory concerns",
  "Other",
];

export default function RejectDealModal({ deal, onCancel, onConfirm }) {
  const [reason, setReason] = useState("");
  const [subcat, setSubcat] = useState("");
  const [rejectedByType, setRejectedByType] = useState("");
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const valid = reason && subcat && rejectedByType;

  const submit = async () => {
    if (!valid) return;
    setSubmitting(true);
    await onConfirm({
      rejection_reason: reason,
      rejection_subcategory: subcat,
      rejected_by_type: rejectedByType,
      rejection_note: note.trim() || null,
    });
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" data-testid="reject-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg">
        <div className="flex items-center justify-between px-6 py-4 border-b" style={{ borderColor: "var(--cw-border)" }}>
          <h2 className="cw-h2">Reject {deal.company_name}</h2>
          <button onClick={onCancel} data-testid="close-reject-btn"><X size={20} /></button>
        </div>
        <div className="p-6 space-y-4">
          <Field label="Rejection reason *">
            <select value={reason} onChange={(e) => setReason(e.target.value)}
              className="w-full h-10 px-3 rounded-md border text-sm bg-white"
              style={{ borderColor: "var(--cw-border)" }}
              data-testid="reject-reason-select">
              <option value="">Select…</option>
              {REASONS.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </Field>
          <Field label="Sub-category *">
            <select value={subcat} onChange={(e) => setSubcat(e.target.value)}
              className="w-full h-10 px-3 rounded-md border text-sm bg-white"
              style={{ borderColor: "var(--cw-border)" }}
              data-testid="reject-subcat-select">
              <option value="">Select…</option>
              <option value="hard_rejected">Hard Rejected</option>
              <option value="maybe_let_go">Maybe Let Go</option>
              <option value="aged_out">Aged Out</option>
            </select>
          </Field>
          <Field label="Rejected by *">
            <div className="flex flex-col gap-2 mt-1">
              {[
                ["vc_firm", "VC Firm decided not to proceed"],
                ["founder", "Founder chose not to proceed"],
              ].map(([val, lab]) => (
                <label key={val} className="flex items-center gap-2 cursor-pointer text-sm">
                  <input type="radio" name="rejected_by" value={val}
                    checked={rejectedByType === val}
                    onChange={() => setRejectedByType(val)}
                    data-testid={`rejected-by-${val}`} />
                  <span>{lab}</span>
                </label>
              ))}
            </div>
          </Field>
          <Field label="Note (optional)">
            <textarea value={note} rows={3} onChange={(e) => setNote(e.target.value)}
              className="w-full px-3 py-2 rounded-md border text-sm bg-white"
              style={{ borderColor: "var(--cw-border)" }}
              data-testid="reject-note-input" />
          </Field>
        </div>
        <div className="border-t px-6 py-4 flex justify-end gap-2" style={{ borderColor: "var(--cw-border)" }}>
          <button onClick={onCancel} className="cw-btn-ghost" data-testid="cancel-reject-btn">Cancel</button>
          <button onClick={submit} disabled={!valid || submitting}
            className="cw-btn-primary" style={{ background: "var(--cw-error)" }}
            data-testid="confirm-reject-btn">
            {submitting ? "Rejecting…" : "Reject Deal"}
          </button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="cw-caption block mb-1">{label}</label>
      {children}
    </div>
  );
}
